export default __webpack_public_path__ + "static/participate3-b2bfae131a4b02224d09a64171d6e6f2.png";